import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';
import { gridSize } from '@atlaskit/theme';

import { Expander } from 'src/components/sidebar';

const CardStyles = xcss({
  display: 'flex',
  flexDirection: 'column',
  padding: 'space.075',
  gap: 'space.200',
  minHeight: `${gridSize() * 10}px`,
});

type Props = {
  label: string;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const MetricCard: React.FC<Props> = props => {
  return (
    <Expander label={props.label}>
      <Box xcss={CardStyles}>{props.children}</Box>
    </Expander>
  );
};
